import type { AuthSession } from "@/pages/auth/api";

const SESSION_TOKEN_KEY = "catiechess.session_token";
const USERNAME_KEY = "catiechess.username";
export const AUTH_CHANGED_EVENT = "catiechess-auth-changed";

function notifyAuthChanged() {
  window.dispatchEvent(new Event(AUTH_CHANGED_EVENT));
}

export function persistSession(session: AuthSession) {
  localStorage.setItem(SESSION_TOKEN_KEY, session.session_token);
  localStorage.setItem(USERNAME_KEY, session.user.username);
  notifyAuthChanged();
}

export function getStoredUsername() {
  return localStorage.getItem(USERNAME_KEY);
}

export function getStoredSessionToken() {
  return localStorage.getItem(SESSION_TOKEN_KEY);
}

export function clearSession() {
  localStorage.removeItem(SESSION_TOKEN_KEY);
  localStorage.removeItem(USERNAME_KEY);
  notifyAuthChanged();
}
